export const footer = {
    copyright: {
        label: "all rights reserved!",
    },
};
